/*
 * Copyright (c) 2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */
import {callWSFunction} from "../APIClient.jsx";

const BuildSessions = function (sessionId) {

    async function listAll() {
        return callWSFunction("buildsession.listAll", {})
    }

    async function closeSession() {
        return callWSFunction("buildsession.closeSession", {
            sessionId: sessionId
        })
    }

    return {
        listAll,
        closeSession
    }
}

export default BuildSessions;